import styled from 'styled-components';

export const PartnerRow = styled.div`
    min-height: 145px;
    border: 1px solid ${props => props.theme.partnerBlockHorizontalBorderColor};

    & > * {
        padding: 15px 20px;

        &:not(:last-child) {
            border-right: 1px solid ${props => props.theme.partnerBlockHorizontalBorderColor};
        }
    }
    .partner-row-logo {
        flex: 0 0 230px;
        width: 230px;
    }

    @media screen and (min-width: ${props => props.theme.medium}) and (max-width: ${props =>
            props.theme.large}) {
        height: auto;
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        height: auto;
        padding: 20px;
        text-align: center;
        max-width: 280px;
        margin: 0 auto 30px;

        & > * {
            border: none !important;
            padding: 0;
        }

        .partner-row-logo {
            border: none;
            margin: 0 auto 20px;
            width: 189px;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/partner/PartnerBlockHorizontalComponentStyle.js